import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { RcFile } from "antd/es/upload";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const uploadCompanyImage = async ({
  owner_id,
  image,
  image_type,
}: {
  owner_id: string;
  image: RcFile | File;
  image_type: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  formData.append("image", image);
  formData.append("image_type", image_type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}uploadUserImage`, formData, config);
};

export const changeOrderById = (id: string): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}changeOrderById/${id}`);
};

export const UpdateChangeOrderStatus = (
  payload: { status: string },
  id: string
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}UpdateChangeOrderStatus/${id}`, payload);
};

export const contractUnwin = (
  contractIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}contractUnwin`, contractIds);
};
